import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import React from 'react'

import { Icon } from '#/components/Icon'
import Colors from '#/styles/Old/Colors'

const Container = styled('div')({
  'display': 'inline-flex',
  'position': 'relative',
  'alignItems': 'center',
  '&:hover .qtip-dialog': {
    opacity: 1,
    pointerEvents: 'auto',
    zIndex: 1,
  },
  '&:hover .qtip-icon': {
    color: Colors.help,
    zIndex: 1,
  },
})

const StyledIcon = styled(Icon)({
  color: Colors.textSecondary,
  transition: 'color 150ms',
})

const Dialog = styled(Paper)({
  minHeight: '34px',
  display: 'flex',
  flexDirection: 'column',
  padding: '12px 24px',
  backgroundColor: '#fff',
  position: 'absolute',
  boxSizing: 'border-box',
  opacity: 0,
  pointerEvents: 'none',
  transition: 'opacity 150ms',
  variants: [
    {
      props: { anchor: 'topLeft' },
      style: {
        top: '-6px',
        left: '-6px',
        paddingLeft: '38px',
      },
    },
    {
      props: { anchor: 'topRight' },
      style: {
        top: '-6px',
        right: '-6px',
        paddingRight: '38px',
      },
    },
    {
      props: { anchor: 'bottomLeft' },
      style: {
        bottom: '-6px',
        left: '-6px',
        paddingLeft: '38px',
      },
    },
    {
      props: { anchor: 'bottomRight' },
      style: {
        bottom: '-6px',
        right: '-6px',
        paddingRight: '38px',
      },
    },
  ],
})

const Title = styled('span')({
  marginBottom: '8px',
  color: Colors.primary,
  fontWeight: 'bold',
})

const QuickInfo = ({
  title,
  children,
  topRight = false,
  bottomLeft = false,
  bottomRight = false,
  width = 350,
}) => {
  let anchor = 'topLeft'
  if (topRight) anchor = 'topRight'
  if (bottomLeft) anchor = 'bottomLeft'
  if (bottomRight) anchor = 'bottomRight'

  return (
    <Container>
      <Dialog className="qtip-dialog" anchor={anchor} sx={{ width }}>
        <Title>{title}</Title>
        {children}
      </Dialog>
      <StyledIcon name="info-outlined" className="qtip-icon" />
    </Container>
  )
}

export default QuickInfo
